import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const NoyaIcon = React.memo(function NoyaIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      opacity={0.8}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 1H1V7H3V3H4C4.53847 3 5 3.46152 5 4V7H7V4C7 2.38456 5.61542 1 4 1Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7C12.6154 7 14 5.61544 14 4C14 2.38456 12.6154 1 11 1C9.38458 1 8 2.38456 8 4C8 5.61544 9.38458 7 11 7ZM11 5C12 5 12 5 12 4C12 3 12 3 11 3C10 3 10 3 10 4C10 5 10 5 11 5Z"
        fill={color}
      />
      <path
        d="M3 8H1V11C1 12.6154 2.38458 14 4 14H5V16H7V10H5V12H4C3.46153 12 3 11.5385 3 11V8Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 14C9.38458 14 8 12.6154 8 11C8 9.38456 9.38458 8 11 8C12.6154 8 14 9.38456 14 11V14H11ZM11 12C12 12 12 12 12 11C12 10 12 10 11 10C10 10 10 10 10 11C10 12 10 12 11 12Z"
        fill={color}
      />
    </svg>
  );
});
